import { render, staticRenderFns } from "./CourseInstructorPanel.vue?vue&type=template&id=6be80ea6&scoped=true"
import script from "./CourseInstructorPanel.vue?vue&type=script&lang=js"
export * from "./CourseInstructorPanel.vue?vue&type=script&lang=js"
import style0 from "./CourseInstructorPanel.vue?vue&type=style&index=0&id=6be80ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be80ea6",
  null
  
)

export default component.exports